<template>
	<div>
		<div class="hero autotrading-bg">
      <div class="inner">
        <h1 v-html="$t('autoTradingPage.text1')"></h1>
        <h5 class="subtitle">{{$t('autoTradingPage.text2')}}</h5>
      </div>
    </div>


		<section class="section3">
      <div class="section-inner">
        <div class="article-col2-container">
          <div class="img-col">
            <img src="@/assets/images/autotrading-image1.png" alt="" />
          </div>
          <div class="text-col">
            <h2 class="section-title">{{$t('autoTradingPage.text3')}}</h2>
            <p>{{$t('autoTradingPage.text4')}}</p>
          </div>
        </div>
      </div>
    </section>

    <section class="section3 dark">
      <div class="section-inner">
        <h2>{{$t('autoTradingPage.text5')}}</h2>
        <div class="spacer"></div>
        <div class="col4-grid text-left variant">
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/derivative-icon1.svg" alt="" /></div>
            <h5>{{$t('autoTradingPage.text6')}}</h5>
            <ul class="col-list">
              <li>{{$t('autoTradingPage.text7')}}</li>
              <li>{{$t('autoTradingPage.text8')}}</li>
              <li>{{$t('autoTradingPage.text9')}}</li>
            </ul>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/derivative-icon2.svg" alt="" /></div>
            <h5>{{$t('autoTradingPage.text10')}}</h5>
            <ul class="col-list">
              <li>{{$t('autoTradingPage.text11')}}</li>
              <li>{{$t('autoTradingPage.text12')}}</li>
            </ul>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/derivative-icon3.svg" alt="" /></div>
            <h5>{{$t('autoTradingPage.text13')}}</h5>
            <ul class="col-list">
              <li>{{$t('autoTradingPage.text14')}}</li>
              <li>{{$t('autoTradingPage.text15')}}</li>
              <li>{{$t('autoTradingPage.text16')}}</li>
              <li>{{$t('autoTradingPage.text17')}}</li>
            </ul>
          </div>
          <div class="col4-grid-item">
            <div><img src="@/assets/icons/derivative-icon4.svg" alt="" /></div>
            <h5>{{$t('autoTradingPage.text18')}}</h5>
            <ul class="col-list">
              <li>{{$t('autoTradingPage.text19')}}</li>
              <li>{{$t('autoTradingPage.text20')}}</li>
              <li>{{$t('autoTradingPage.text21')}}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="section3">
      <div class="section-inner">
        <h2>{{$t('autoTradingPage.text22')}}</h2>
        <div class="spacer"></div>
        <div class="col3-grid center">
          <div class="col3-grid-item">
            <div><img class="screen-images" src="@/assets/images/autotrading-image2.png" alt="" /></div>
            <h5>{{$t('autoTradingPage.text23')}}</h5>
						<p>{{$t('autoTradingPage.text24')}}</p>
          </div>
          <div class="col3-grid-item">
            <div><img class="screen-images" src="@/assets/images/autotrading-image3.png" alt="" /></div>
            <h5>{{$t('autoTradingPage.text25')}}</h5>
						<p>{{$t('autoTradingPage.text26')}}</p>
          </div>
          <div class="col3-grid-item">
            <div><img class="screen-images" src="@/assets/images/autotrading-image4.png" alt="" /></div>
            <h5>{{$t('autoTradingPage.text27')}}</h5>
						<p>{{$t('autoTradingPage.text28')}}</p>
          </div>
        </div>
      </div>
    </section>


		<section class="section3 light-gray">
      <div class="section-inner">
        <h2 class="section-title">{{$t('autoTradingPage.text29')}}</h2>
        <p>{{$t('autoTradingPage.text30')}}</p>
        <router-link to="contact" class="contact-us"><BtnPrimary text="Contact us" /></router-link>
      </div>
    </section>
	</div>
</template>

<script>
import BtnPrimary from '@/components/BtnPrimary.vue';

export default {
	name: 'AutoTradingPage',
	components: { BtnPrimary },
	data() {
		return {
			
		};
	},

	mounted() {
		
	},

	methods: {
		
	},
};
</script>

<style lang="scss" scoped>

</style>